module.exports = __webpack_public_path__ + "img/KrishnaNagaraj.17011b7d.png";